<template>
  <base-card no-padding>
    <ul v-if="isLoading">
      <li v-for="i in 3" :key="i" :class="['tw-flex tw-justify-between tw-items-center tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6', { 'tw-border-b': i < 3 }]">
        <div>
          <div class="tw-flex tw-items-center tw-mt-1.5 tw-mb-1">
            <base-skeleton-loader class="tw-w-24 tw-h-3" />
            <base-skeleton-loader class="tw-w-16 tw-h-3 tw-ml-2 tw-rounded-full" />
          </div>
          <base-skeleton-loader class="tw-w-12 tw-h-2 tw-mt-2.5 tw-mb-0.5" />
        </div>
        <div class="tw-flex tw-items-center">
          <base-skeleton-loader class="tw-w-12 tw-h-3" />
          <base-skeleton-loader class="tw-ml-3 tw-h-5 tw-w-5 tw-rounded-full" />
        </div>
      </li>
    </ul>
    <div class="tw-text-gray-600 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-else-if="!charges.length">No Results Found</div>
    <ul class="tw-mb-0" v-else>
      <li v-for="(charge, chargeIndex) in charges" :key="charge.chargeId">
        <user-charge-list-item :charge="charge" :isLast="chargeIndex + 1 === charges.length" :userId="userId" :userBusinessPlanId="userBusinessPlanId" />
      </li>
    </ul>
  </base-card>
</template>

<script>
import { orderBy } from "lodash";
import UserChargeListItem from "@/views/user/components/UserChargeListItem.vue";

export default {
  components: {
    UserChargeListItem,
  },
  props: {
    userId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isLoading: false,
      charges: [],
    };
  },
  computed: {
    orderedCharges() {
      return orderBy(this.charges, ["createdDate"], ["desc"]);
    },
  },
  created() {
    this.getCharges();
    this.EventBus.$on("member_update", this.getCharges);
  },
  beforeDestroy() {
    this.EventBus.$off("member_update", this.getCharges);
  },
  methods: {
    async getCharges() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/users/${this.userId}/userplans/${this.userBusinessPlanId}/charges`);
        this.charges = response.data;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
